module.exports = __webpack_public_path__ + "img/glf_gemlandtoken.41773b8.png";